import {Injectable} from '@angular/core';
import {NbIcon, NbIconDefinition, NbIconLibraries, NbIconPack, NbIconPackParams, NbSvgIcon} from '@nebular/theme';

@Injectable({providedIn: 'root'})
export class CompoIconLibraries extends NbIconLibraries {

  private readonly iconReplacements: Record<string, string> = {
    'attach': 'paperclip',
    'attach-2': 'paperclip',
    'person': 'user-round',
    'person-add': 'user-round-plus',
    'close': 'x',
    'people': 'users-round',
    'shake': 'store',
    'cube': 'box',
    'car': 'truck',
    'folder-remove': 'folder-minus',
    'menu-arrow': 'panel-right-open',
    'options-2': 'settings',
    'file-remove': 'file-minus',
    'checkmark-circle-2': 'check',
    'checkmark': 'check',
    'person-done': 'user-round-pen',
    'refresh': 'refresh-ccw',
    'flash': 'zap',
  };

  getIcon(name: string, pack?: string): NbIconDefinition | null {
    if (name && !pack) {
      const baseName = name.replace('-outline', '');
      name = this.iconReplacements[baseName] || baseName;
    }

    return super.getIcon(name, pack);
  }

  protected getIconFromPack(name: string, pack: NbIconPack): NbIcon | string | null {
    if (pack.name === 'nebular-essentials') {
      return super.getIconFromPack(name, pack);
    }
    return name;
  }

  protected createSvgIcon(name: string, content: NbIcon | string, params: NbIconPackParams): NbSvgIcon {
    if (typeof content === 'string' && content.indexOf('<svg') === 0) {
      return super.createSvgIcon(name, content, params);
    }

    // Иконка инжектится строкой (innerHTML), реального Angular-компонента <tui-icon> нет.
    // Тег оставляем <tui-icon> (с самодостаточными inline-стилями), чтобы глобальные
    // CSS-селекторы проекта на `tui-icon` / `tui-icon[icon="..."]` продолжали работать.
    // CSS Taiga (scoped по [data-tui-version]) на этот сырой тег не действует — рендерим сами.
    // ВАЖНО: SVG-иконки Taiga 5 задают stroke-width="calc((100vw - 100vh) / 10)" +
    // vector-effect="non-scaling-stroke". В квадратном боксе 100vw-100vh = 0 → штрих 0 → пусто
    // (ни <img>, ни background, ни простая mask не видны). Настоящий tui-icon компенсирует это
    // горизонтальным растяжением маски на 10×--tui-stroke-width — повторяем тот же приём.
    const url = `assets/taiga-ui/icons/${name}.svg`;
    return content instanceof NbSvgIcon
      ? content
      : new NbSvgIcon(
        name,
        `<tui-icon icon="${name}" style="display:inline-block;width:1em;height:1em;background-color:currentColor;` +
        `-webkit-mask:url(${url}) no-repeat center;mask:url(${url}) no-repeat center;` +
        `-webkit-mask-size:calc(100% + 10 * var(--tui-stroke-width)) 100%;` +
        `mask-size:calc(100% + 10 * var(--tui-stroke-width)) 100%"></tui-icon>`,
        params
      );
  }
}
